import type { SectionMeta } from '@sola/schema/lib/schema.ts';
import { ThemesEnum } from '@sola/schema/lib/schema.ts';

/**
 * Shared `FlexibleSection` layout presets.
 *
 * These are production layout config, not mock data. They previously lived in
 * `../mocks/mocks.tsx`, which meant every template importing a preset also
 * pulled ~1600 lines of mock fixtures (and, transitively, the Storybook
 * helpers and the whole CMS organism graph) into the client bundle.
 *
 * Templates almost always spread a preset and override `anchor`, so the
 * `test-*` anchor defaults are kept verbatim from the original definitions to
 * avoid changing rendered output.
 */
export const FSmeta: SectionMeta = {
  theme: ThemesEnum.enum.white,
  fullWidth: false,
  dividerBelow: false,
  layoutRatio: '1-1',
  overlap: false,
  anchor: 'test-default',
};

export const FSmeta2Col: SectionMeta = {
  theme: ThemesEnum.enum.white,
  fullWidth: false,
  dividerBelow: false,
  layoutRatio: '2-1',
  overlap: false,
  anchor: 'test-default',
};

export const FSmetaLight: SectionMeta = {
  ...FSmeta,
  theme: ThemesEnum.enum.lightBlue,
  anchor: 'test-light',
};

export const FSmetaDark: SectionMeta = {
  ...FSmeta,
  theme: ThemesEnum.enum.darkBlue,
  anchor: 'test-dark',
};

export const FSmetaFullBleed: SectionMeta = {
  ...FSmeta,
  fullWidth: true,
};

export const FSmetaFullBleedLight: SectionMeta = {
  ...FSmetaFullBleed,
  theme: ThemesEnum.enum.lightBlue,
  anchor: 'test-light',
};

export const FSmetaFullBleedDark: SectionMeta = {
  ...FSmetaFullBleed,
  theme: ThemesEnum.enum.darkBlue,
  anchor: 'test-dark',
};

export const FSmetaFullBleedOverlap: SectionMeta = {
  ...FSmetaFullBleed,
  overlap: true,
  anchor: 'test-overlap',
};
